// extracted by mini-css-extract-plugin
export default {"UserPageLoading":"UserPage_UserPageLoading__p56f9","UserPageSuccess__tabsNav":"UserPage_UserPageSuccess__tabsNav__nwLQu"};